module.exports = __webpack_public_path__ + "img/About_Freelancers_LIGHT-04.6e65807.svg";